import script from "./FlowReportFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowReportFilters.vue?vue&type=script&lang=ts&setup=true"

import "./FlowReportFilters.vue?vue&type=style&index=0&id=52b6238e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b6238e"]])

export default __exports__